import Box from "@mui/material/Box";

export default function ProductSidePanel({
  children,
  component = "aside",
  mobileTopOffset = 0,
  wide = false,
  sx,
}) {
  return (
    <Box
      component={component}
      sx={(theme) => ({
        bgcolor: theme.palette.background.paper,
        borderLeft: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        height: { xs: `calc(100vh - ${mobileTopOffset}px)`, md: "100%" },
        minHeight: 0,
        position: { xs: "fixed", md: "absolute" },
        right: 0,
        top: { xs: mobileTopOffset, md: 0 },
        maxWidth: "100%",
        width: {
          xs: "100%",
          md: wide ? theme.product.layout.wideSidePanelWidth : theme.product.layout.sidePanelWidth,
        },
        zIndex: { xs: theme.zIndex.modal, md: "auto" },
        ...(typeof sx === "function" ? sx(theme) : sx),
      })}
    >
      {children}
    </Box>
  );
}
